import { HttpService } from "@/core";
import { BrandPageResp, BrandListResp, BrandDetailResp, BrandReq } from "./brand.interface";

export class BrandService {
  static usePageApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/brand/pageList",
        params,
      });
    return HttpService.usePagination<BrandPageResp>(api);
  }

  static useListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/brand/list",
        params,
      });
    return HttpService.useRequest<BrandListResp>(api);
  }

  static useSimpleListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/brand/brandList",
        params,
      });
    return HttpService.useRequest<BrandDetailResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/brand/${id}`,
      });
    return HttpService.useRequest<BrandDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: BrandReq) =>
      HttpService.axios({
        method: "POST",
        url: "/brand",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: BrandReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/brand/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/brand/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useImportPageApi() {
    const api = (url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/brand/import`,
        data: {
          url,
        },
      });
    return HttpService.useRequest<void>(api);
  }

  static useUploadBrand() {
    const api = (url) =>
      HttpService.axios({
        url: "/brand/batchImportCheck",
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<any>(api);
  }

  static useFinishUpload() {
    const api = (data) =>
      HttpService.axios({
        url: "/brand/batchImportCheckAdd",
        data: {
          brandList: data,
        },
        method: "post",
      });
    return HttpService.useRequest<void>(api);
  }
}
